<template>
    <div class="invite-wrapper">
        <div class="offset">
            <div class="header"></div>
            <div class="invite">
                <form class="content" v-if="!inviteConfirmed" @submit.prevent="submit">
                    <h1>Подтверждение участия</h1>
                    <p>Придумайте пароль для входа в аккаунт и подтвердите регистрацию</p>
                    <ModelPassword
                        class="input"
                        label="Придумайте пароль"
                        v-model="password"
                        type="password"
                        autocomplete="new-password"
                        id="new-password"
                        aria-label="Пароль"
                        aria-required="true"
                        autocapitalize="off"
                        autocorrect="off"
                        name="password"
                        :invalidate-function="validatePassword"
                        :disabled="loading"
                    />
                    <ModelPassword
                        class="input"
                        label="Повторите пароль"
                        v-model="repeat"
                        type="password"
                        autocomplete="new-password"
                        id="new-password-repeat"
                        aria-label="Пароль"
                        aria-required="true"
                        autocapitalize="off"
                        autocorrect="off"
                        name="repeat"
                        :invalidate-function="validateRepeat"
                        :disabled="loading"
                    />
                    <ModelCheckbox
                        class="checkbox"
                        v-model="agree"
                        :label="agreementHtml"
                        multiline
                        :disabled="loading"
                    />
                    <button class="forumBtn" :disabled="!isValid || loading">Подтвердить регистрацию</button>
                </form>

                <div class="content" v-if="inviteConfirmed">
                    <h1>Отлично!</h1>
                    <p>Вы подтвердили свое участие</p>
                    <!-- <p>Через несколько секунд вы будете перенаправленны</p> -->
                    <button class="forumBtn" @click="goToAccount">Продолжить</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModelCheckbox from '@/components/UI/models/ModelCheckbox';
import ModelPassword from '@/components/UI/models/ModelPassword';
import { post } from '../tools/http';
import { mapGetters, mapActions } from 'vuex';
import appBaseUrl from '@/tools/appBaseUrl';

export default {
    name: 'Invite',
    data: function () {
        return {
            inviteConfirmed: false,
            password: '',
            repeat: '',
            agree: false,
            showErrors: false,
            loading: false,
            inviteQuota: null,
        };
    },
    computed: {
        ...mapGetters(['isAuthorized', 'legal']),

        hash() {
            return this.$route.params.hash;
        },

        agreementHtml() {
            return `Я принимаю условия <a target="_blank" href="${this.legal.user_agreement}">Пользовательского соглашения</a><br>
            и даю свое согласие на передачу персональной<br>
            информации третьим лицам на условиях, определенных<br>
            <a target="_blank" href="${this.legal.politic}">Политикой обработки персональных данных</a><br>
            (для совершеннолетних пользователей).`;
        },

        validatePassword() {
            return (v) => {
                if (!this.showErrors) {
                    return '';
                }
                if (!v) {
                    return 'Обязательное поле';
                }
                if (!/^\S+$/u.test(v)) {
                    return 'Ваш пароль содержит недопустимые симоволы (пробел)';
                }
                if (v.length < 8) {
                    return 'Длина пароля должна быть не менее 8 символов';
                }
                if (!/^(?=.*[a-zа-я])(?=.*[A-ZА-Я])(?=.*[0-9])(?=.{8,})/.test(v)) {
                    return 'Пароль должен содержать цифры, строчные и прописные буквы';
                }
                return '';
            };
        },
        validateRepeat() {
            return (v) => {
                if (!this.showErrors) {
                    return '';
                }
                if (this.validatePassword(this.password)) {
                    return '';
                }
                if (!v) {
                    return 'Обязательное поле';
                }
                if (v !== this.password) {
                    return 'Пароли должны совпадать';
                }
                return '';
            };
        },
        isValid() {
            return !this.validatePassword(this.password) && !this.validateRepeat(this.repeat);
        },
    },
    async created() {
        await this.checkStatus();
        await this.loadLegal();
    },
    methods: {
        ...mapActions(['showAppLoader', 'hideAppLoader', 'loadLegal']),
        submit() {
            this.showErrors = true;
            if (this.isValid && this.agree) {
                this.showErrors = false;
                this.invite();
            }
        },
        async invite() {
            this.loading = true;
            let res = await post(
                'profile',
                'invite/accept',
                {
                    token: this.hash,
                    password: this.password,
                },
                true
            );
            this.loading = false;
            if (res && res.confirmed) {
                this.inviteConfirmed = true;
                setTimeout(() => {
                    this.goToAccount();
                }, 5000);
            }
        },
        async checkStatus() {
            this.showAppLoader();
            let res = await post(
                'profile',
                'invite/get',
                {
                    token: this.hash,
                },
                true
            );
            if (!res || res.inviteFound === false) {
                this.$router.push({ name: '404' });
                this.hideAppLoader();
            } else {
                this.inviteQuota = res.inviteQuota;
                if (res.inviteActive) {
                    if (this.isAuthorized) {
                        localStorage.setItem('post_logout_invite_state', JSON.stringify(this.$route.params));
                        this.$root.securityService.signOut(`${appBaseUrl}invite/redirect/post-logout/`);
                    } else {
                        this.hideAppLoader();
                    }
                } else {
                    this.goToAccount();
                }
            }
        },
        goToAccount() {
            this.hideAppLoader();
            this.$router.push({ name: 'account-projects' });
        },
    },
    watch: {
        password() {
            this.showErrors = false;
        },
        repeat() {
            this.showErrors = false;
        },
    },
    components: {
        ModelPassword,
        ModelCheckbox,
    },
};
</script>

<style scoped lang="scss">
@import '../styles/variables';
@import '../styles/rem';
@import '../styles/mrem';
h1 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: rem(24);
    line-height: rem(42);
}

p {
    font-family: 'Proxima Nova', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: rem(18);
    line-height: rem(24);
    color: #000000;
    text-align: center;
}

@media (max-width: $vm) {
    h1 {
        font-size: mrem(24);
        line-height: mrem(28);
    }
    p {
        font-size: mrem(16);
        line-height: mrem(20);
    }
}

.invite-wrapper {
    width: 100%;
    height: calc(100vh - 5rem);

    .offset {
        width: 80rem;
        margin: 0 auto;
        height: 100%;
        .header {
            height: 5rem;
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .wait {
            height: calc(100vh - 10rem);
        }

        .invite {
            width: 100%;
            background: white;
            height: calc(100vh - 15rem);
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .content {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .text {
                    font-size: rem(32);
                    color: black;
                    font-weight: bold;
                }
                .input {
                    width: rem(450);
                }
                .checkbox {
                    width: rem(450);
                    margin-top: rem(8);
                }
                .forumBtn {
                    width: rem(280);
                    height: rem(48);
                    background: #d1004a;
                    border-radius: rem(4);
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-weight: 500;
                    font-size: rem(16);
                    font-family: Montserrat;
                    cursor: pointer;
                    outline: none;
                    border: 0;

                    &:disabled {
                        opacity: 0.8;
                    }
                }
            }
        }
    }
}

@media (max-width: $vm) {
    .invite-wrapper {
        width: 100%;
        height: calc(100vh - 16rem);
        margin-top: 10rem;

        .offset {
            width: 100rem;
            margin: 0 auto;
            height: 100%;
            .header {
                height: 10rem;
                display: flex;
                flex-direction: row;
                align-items: center;
                .back {
                    margin-left: 5rem;
                    cursor: pointer;
                    font-size: 5rem;
                }
            }

            .wait {
                height: calc(100vh - 16rem);
            }

            .invite {
                width: 100%;
                background: white;
                align-items: flex-start;
                padding-top: mrem(40);

                .iframe {
                    width: 100%;
                    height: calc(100vh - 25rem);
                }

                .none {
                    display: none;
                }

                .content {
                    .input {
                        width: 90rem;
                    }
                    .checkbox {
                        width: 90rem;
                    }
                    .forumBtn {
                        width: mrem(280);
                        height: mrem(48);
                        border-radius: mrem(4);
                        font-size: mrem(16);
                    }
                }
            }
        }
    }
}
</style>
